export default __webpack_public_path__ + "static/bg_1400-de2963bf47742b41d1b7530cc44631ba.jpg";